import React from 'react';

export const TableHeader = () => (
    <thead className="kt-datatable__head">
    <tr className="kt-datatable__row">
        <th width="200px" className="kt-datatable__cell"><span>Наименование</span></th>
        <th width="auto" className="kt-datatable__cell"></th>
        <th style={{textAlign: 'center'}} width="120px" className="kt-datatable__cell"><span>Дата реализации</span></th>
        <th style={{textAlign: 'center'}} width="120px" className="kt-datatable__cell"><span>Количество</span></th>
        <th style={{textAlign: 'center'}} width="120px" className="kt-datatable__cell"><span>Цена</span></th>
        <th style={{textAlign: 'center'}} width="120px" className="kt-datatable__cell"><span>Сумма</span></th>
    </tr>
    </thead>
);